import tableConfig from "./advancedTableColumnsControl.json";

export const getContactBaseColumns = () => [
  {
    field: "fullName",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "businessName",
    headerName: "Business",
    flex: 1,
  },
  {
    field: "phone",
    headerName: "Phone",
    flex: 1,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
  },
];

export const getContactDateUpdatedColumn = () => ({
  field: "dateUpdated",
  headerName: "Last Updated",
  renderCell: ({ row }) => {
    if (!row.dateUpdated) return "";
    const d = typeof row.dateUpdated === "number"
      ? new Date(row.dateUpdated)
      : row.dateUpdated.toDate();
    return d.toISOString().split("T")[0];
  },
});

export const getContactColumnsWithHighlighting = () => [
  {
    field: "fullName_lc",
    headerName: "Name",
    renderCell: ({ row }) => (
      <div dangerouslySetInnerHTML={{ __html: row.displayFullName || row.fullName }} />
    ),
  },
  {
    field: "businessName_lc",
    headerName: "Business",
    renderCell: ({ row }) => (
      <div dangerouslySetInnerHTML={{ __html: row.displayBusinessName || row.businessName }} />
    ),
  },
  {
    field: "phone",
    headerName: "Phone",
    renderCell: ({ row }) => (
      <div dangerouslySetInnerHTML={{ __html: row.displayPhone || row.phone }} />
    ),
  },
  {
    field: "email_lc",
    headerName: "Email",
    renderCell: ({ row }) => (
      <div dangerouslySetInnerHTML={{ __html: row.displayEmail || row.email }} />
    ),
  },
  {
    field: "architect",
    headerName: "Architect",
    renderCell: ({ row }) => row.architect ? "True" : "False",
  },
  {
    field: "client",
    headerName: "Client",
    renderCell: ({ row }) => row.client ? "True" : "False",
  },
  {
    field: "contractor",
    headerName: "Contractor",
    renderCell: ({ row }) => row.contractor ? "True" : "False",
  },
  {
    field: "employee",
    headerName: "Employee",
    renderCell: ({ row }) => row.employee ? "True" : "False",
  },
  {
    field: "engineer",
    headerName: "Engineer",
    renderCell: ({ row }) => row.engineer ? "True" : "False",
  },
  {
    field: "filingRep",
    headerName: "Filing Rep",
    renderCell: ({ row }) => row.filingRep ? "True" : "False",
  },
  {
    field: "owner",
    headerName: "Owner",
    renderCell: ({ row }) => row.owner ? "True" : "False",
  },
  {
    field: "tenant",
    headerName: "Tenant",
    renderCell: ({ row }) => row.tenant ? "True" : "False",
  },
];